import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {HelperService} from './helpers';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor(private http: HttpClient, private helper: HelperService) {
  }

  public uploadImage(image: File, title?: string): Observable<any> {
    const formData = new FormData();

    if (!title) {
      title = image.name;

    }

    formData.append('file', image);
    formData.append('title', title);
    formData.append('caption', title);

    return this.http.post(this.helper.getApiUrl('/media'), formData);

  }
}
